import React, { useEffect, useRef, useState } from "react";
import * as IoIcons from "react-icons/io";
import "../estilos.css";
import { Row, Label, odal, ModalHeader, ModalBody, ModalFooter, Modal, Button, Input, Alert } from "reactstrap";
import Moment from 'moment';
import { cambioUbicacionSeriales, } from "../queries/DCUbicaciones";
import TimeField from "react-simple-timefield";
import { GetPProduccionGeneral, GetRecibaSerialesID, GetResumenOperacionID } from "../queries/Queries";
//import { API } from "aws-amplify";
import {
  createPProduccionGeneral, createPProduccionUltimoNumero,
  updatePProduccionGeneral, updatePProduccionUltimoNumero, updateRecibaSeriales, updateRecibaSerialesMP,
  updateResumenOperacion
} from "../../graphql/mutations";
import { listPProduccionUltimoNumeros } from "../../graphql/queries";
import { generateClient } from "aws-amplify/api";

const API = generateClient();

function EditarRO({
  dResumenO,
  bColor,
  btitle,
  modulo,
  usuario,
  tipo,//Carga, CargaPlaneado, CargaPintado
  valorDeREtorno
}) {


  const [modalCP, setModalCP] = useState(false);
  const [cargando, setCargando] = useState(false);
  const toggleCP = () => setModalCP(!modalCP);
  const [piezasenCargando, setPiezasenCargando] = useState(0);
  const [rackCarga, setRackCarga] = useState(0);
  const [numeroRackCarga, setnumeroRackCarga] = useState("");
  const [rackTipo, setRackTipo] = useState("");
  const [cicloCarga, setCicloCarga] = useState(1);
  const [datosOperacion, setDatosOperacion] = useState(dResumenO);
  const [fecha, setfecha] = useState(new Date());
  const [idProduccionGeneral, setIDProduccionGeneral] = useState("");
  const [fechaCarga, setfechaCarga] = useState(Moment(fecha).format("YYYY-MM-DD"));
  const [fechaPintado, setfechaPintado] = useState(Moment(fecha).format("YYYY-MM-DD"));
  const [horaCarga, sethoraCarga] = useState(Moment(fecha).format("HH:mm"));
  const [horaPintado, sethoraPintado] = useState(Moment(fecha).format("HH:mm"));
  const [mensajeAlert, setMensajeAlert] = useState("Hola");
  const [color, setColor] = useState("warning");
  const [aVisible, setAVisible] = useState(false);
  const onDismiss = () => setAVisible(false);



  useEffect(() => {
    setDatosOperacion(dResumenO);
    //fetchROperacion();
  }, []);


  //Obtiene los datos guardados de las   rOperacion
  async function fetchROperacion() {

    //Se obtienen los datos del resumen de operación
    const apiData = await GetResumenOperacionID(dResumenO.id);
    //Se obtienen los datos del resumen de operación
    setDatosOperacion(apiData);
  }
  async function verCargaPintado(produccion) {
    setCargando(true);
    //valorDeREtorno("Mensaje de Carga e inspección");

    setPiezasenCargando(0)
    toggleCP();
    setCargando(false);
    setAVisible(false);

  }

  // handle input change


  function handleInputChange(valor) {
    return valor
  }
  function handleInputChangeNum(e) {
    var valor = "";
    const re = /^[0-9\.]+$/;
    if (e.target.value === '' || re.test(e.target.value)) {
      valor = e.target.value;
    }
    return valor
  }
  async function guardarCambios() {
    var resultado = { mensaje: "", color: "primary", completo: false, registros: {} };
    setAVisible(false);
    setCargando(true);
    setColor("warning");

    try {
      setMensajeAlert("Iniciando la el proceso: " + datosOperacion.fecha)

      //Se obtienen los datos del resumen de operación
      const datosOPN = await GetResumenOperacionID(dResumenO.id);
      if (datosOperacion.defectuso) {
        datosOPN.defectuso = datosOperacion.defectuso;
      }
      if (datosOperacion.defectuso && datosOPN.totalInspeccionado) {
        datosOPN.porcentajeDefectuoso = (parseFloat(datosOperacion.defectuso ?
          datosOperacion.defectuso : 0) * 100) / parseFloat(datosOPN.totalInspeccionado ? datosOPN.totalInspeccionado : 0);
      }
      if (datosOperacion.primerContribuidor) {
        datosOPN.primerContribuidor = datosOperacion.primerContribuidor;
      }
      if (datosOperacion.segundoContribuidor) {
        datosOPN.segundoContribuidor = datosOperacion.segundoContribuidor;
      }
      if (datosOperacion.tercerContribuidor) {
        datosOPN.tercerContribuidor = datosOperacion.tercerContribuidor;
      }
      if (datosOperacion.primerContribuidorNP) {
        datosOPN.primerContribuidorNP = datosOperacion.primerContribuidorNP;
      }
      if (datosOperacion.segundoContribuidorNP) {
        datosOPN.segundoContribuidorNP = datosOperacion.segundoContribuidorNP;
      }
      if (datosOperacion.tercerContribuidorNP) {
        datosOPN.tercerContribuidorNP = datosOperacion.tercerContribuidorNP;
      }
      if (datosOperacion.sqftProducidos) {
        datosOPN.sqftProducidos = datosOperacion.sqftProducidos;
      }
      if (datosOperacion.gastosQuimicos) {
        datosOPN.gastosQuimicos = datosOperacion.gastosQuimicos;
      }
      if (datosOperacion.consumoAgua) {
        datosOPN.consumoAgua = datosOperacion.consumoAgua;
      }
      if (datosOperacion.gastosQuimicos && datosOperacion.sqftProducidos) {
        datosOPN.costoQuimicoSQFT = parseFloat(datosOperacion.gastosQuimicos) / parseFloat(datosOperacion.sqftProducidos);
      }
      if (datosOperacion.gastosQuimicos && datosOPN.facturacionPlaneada) {
        datosOPN.costoQuimicovsFacturacion = (parseFloat(datosOperacion.gastosQuimicos) * 100) / parseFloat(datosOPN.facturacionPlaneada);
      }
      if (datosOperacion.apFaltaCarga) {
        datosOPN.apFaltaCarga = datosOperacion.apFaltaCarga;
      }
      if (datosOperacion.apIncapacidadCarga) {
        datosOPN.apIncapacidadCarga = datosOperacion.apIncapacidadCarga;
      }
      if (datosOperacion.apFaltaInspeccion) {
        datosOPN.apFaltaInspeccion = datosOperacion.apFaltaInspeccion;
      }
      if (datosOperacion.apIncapacidadInspeccion) {
        datosOPN.apIncapacidadInspeccion = datosOperacion.apIncapacidadInspeccion;
      }
      if (datosOperacion.apFaltaCargaPC) {
        datosOPN.apFaltaCargaPC = datosOperacion.apFaltaCargaPC;
      }
      if (datosOperacion.apIncapacidadCargaPC) {
        datosOPN.apIncapacidadCargaPC = datosOperacion.apIncapacidadCargaPC;
      }
      if (datosOperacion.apFaltaInspeccionPC) {
        datosOPN.apFaltaInspeccionPC = datosOperacion.apFaltaInspeccionPC;
      }
      if (datosOperacion.apIncapacidadInspeccionPC) {
        datosOPN.apIncapacidadInspeccionPC = datosOperacion.apIncapacidadInspeccionPC;
      }
      if (datosOperacion.estatusPendientesMejoras) {
        datosOPN.estatusPendientesMejoras = datosOperacion.estatusPendientesMejoras;
      }
      if (datosOperacion.accionesaTomar) {
        datosOPN.accionesaTomar = datosOperacion.accionesaTomar;
      }

      datosOPN.Reg_Mod_Usuario = usuario.usuario;
      delete datosOPN.createdAt;
      delete datosOPN.updatedAt;
      delete datosOPN.__typename;
      resultado.mensaje = "Problemas al actualizar el plan de producción general 2 " + JSON.stringify(datosOPN)
      setMensajeAlert(resultado.mensaje);
      await API.graphql({ query: updateResumenOperacion, variables: { input: datosOPN } });

      window.scrollTo(0, 0);
      setMensajeAlert("Operación exitosa");
      //setDatosOperacion({});
      setColor("primary");
      resultado.completo = true;
      valorDeREtorno(resultado);
      setCargando(false);
      setAVisible(true);
      toggleCP();
    } catch (e) {
      window.scrollTo(0, 0);
      /*setMensajeAlert(
        "No fue posible realizar la operación: revise su conexión a internet, recargue la página y vuelva a intentar, si el error persiste, favor de comunicarse a sistemas"
      );*/
      setColor("warning");
      setCargando(false);
      setAVisible(true);
      valorDeREtorno(resultado);
    }
  }

  return (
    <>
      <Row>
        {/*cargando === true && (
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
            <img width="150px" src="assets/img/preloader.gif" />
          </div>
        )*/}
      </Row>
      {cargando === false && (
        <button
          class={"btn-" + bColor + " cbutton"}
          title={btitle}
          //style={{ display: "none" }}
          onClick={() => verCargaPintado(datosOperacion)}
        >
          <IoIcons.IoIosCreate />
        </button>
      )}
      <Modal isOpen={modalCP} toggle={toggleCP} >
        <ModalHeader toggle={toggleCP}>
          {btitle}
        </ModalHeader>
        <ModalBody>
          {/*JSON.stringify(datosOperacion)*/}
          <Row>
            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
              <Label className="tbold">Fecha</Label>
            </div>
            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
              <Label>
                {datosOperacion.fecha}
              </Label>
            </div>
          </Row>
          {(usuario.ResumenOperacionEDefectos ? usuario.ResumenOperacionEDefectos : false) === true && (
            <Row>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Label className="tbold">Defectuoso BTI</Label>
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Input
                  name="defectuso"
                  maxLength={20}
                  value={
                    datosOperacion.defectuso
                  }
                  onChange={(e) =>
                    setDatosOperacion({ ...datosOperacion, defectuso: (handleInputChangeNum(e)) })
                  }
                  placeholder=""
                />
              </div>
              {/*<div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Label className="tbold">% Defectuoso</Label>
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Label>
                  {datosOperacion.porcentajeDefectuoso}
                </Label>
              </div>*/}
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Label className="tbold">1er contribuidor</Label>
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <select
                  name="primerContribuidor"
                  className=" custom-select"
                  onChange={(e) => setDatosOperacion({ ...datosOperacion, primerContribuidor: e.target.value })}
                >
                  <option
                    value=""
                    selected={datosOperacion.primerContribuidor ? false : true}>
                  </option>
                  <option
                    value="D01 Rayaduras/Golpes"
                    selected={datosOperacion.primerContribuidor === "D01 Rayaduras/Golpes" ? true : false}>
                    D01 Rayaduras/Golpes
                  </option>
                  <option
                    value="D02 Grumos/Impurezas"
                    selected={
                      datosOperacion.primerContribuidor === "D02 Grumos/Impurezas" ? true : false}>
                    D02 Grumos/Impurezas
                  </option>
                  <option
                    value="D03 Falta de escurrido"
                    selected={
                      datosOperacion.primerContribuidor === "D03 Falta de escurrido" ? true : false}>
                    D03 Falta de escurrido
                  </option>
                  <option
                    value="D04 Pin Hole (Crater)"
                    selected={
                      datosOperacion.primerContribuidor === "D04 Pin Hole (Crater)" ? true : false}>
                    D04 Pin Hole (Crater)
                  </option>
                  <option
                    value="D04 L)Limpieza"
                    selected={
                      datosOperacion.primerContribuidor === "D04 L)Limpieza" ? true : false}>
                    D04 L)Limpieza)
                  </option>
                  <option
                    value="D04 F)Falso Contacto)"
                    selected={
                      datosOperacion.primerContribuidor === "D04 F)Falso Contacto)" ? true : false}>
                    D04 F)Falso Contacto)
                  </option>
                  <option
                    value="D05 Contaminacion(Nube, Oxido,Grasa)"
                    selected={
                      datosOperacion.primerContribuidor === "D05 Contaminacion(Nube, Oxido,Grasa)" ? true : false}>
                    D05 Contaminacion(Nube, Oxido,Grasa)
                  </option>
                  <option
                    value="D06 Cenizo"
                    selected={
                      datosOperacion.primerContribuidor === "D06 Cenizo" ? true : false}>
                    D06 Cenizo
                  </option>
                  <option
                    value="D07 Burbuja"
                    selected={
                      datosOperacion.primerContribuidor === "D07 Burbuja" ? true : false}>
                    D07 Burbuja
                  </option>
                  <option
                    value="D08 Falta de Pintura"
                    selected={
                      datosOperacion.primerContribuidor === "D08 Falta de Pintura" ? true : false}>
                    D08 Falta de Pintura
                  </option>
                  <option
                    value="D9  Dañada/doblada"
                    selected={
                      datosOperacion.primerContribuidor === "D9  Dañada/doblada" ? true : false}>
                    D9  Dañada/doblada
                  </option>
                  <option
                    value="D10 Partes mezcladas"
                    selected={
                      datosOperacion.primerContribuidor === "D10 Partes mezcladas" ? true : false}>
                    D10 Partes mezcladas
                  </option>
                  <option
                    value="D11 Otros"
                    selected={
                      datosOperacion.primerContribuidor === "D11 Otros" ? true : false}>
                    D11 Otros
                  </option>
                </select>
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Label className="tbold">1er contribuidor NP</Label>
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Input
                  name="primerContribuidorNP"
                  maxLength={20}
                  value={
                    datosOperacion.primerContribuidorNP
                  }
                  onChange={(e) =>
                    setDatosOperacion({ ...datosOperacion, primerContribuidorNP: e.target.value })
                  }
                  placeholder=""
                />
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Label className="tbold">2do Contribuidor</Label>
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <select
                  name="segundoContribuidor"
                  className=" custom-select"
                  onChange={(e) => setDatosOperacion({ ...datosOperacion, segundoContribuidor: e.target.value })}
                >
                  <option
                    value=""
                    selected={datosOperacion.segundoContribuidor ? false : true}>
                  </option>
                  <option
                    value="D01 Rayaduras/Golpes"
                    selected={datosOperacion.segundoContribuidor === "D01 Rayaduras/Golpes" ? true : false}>
                    D01 Rayaduras/Golpes
                  </option>
                  <option
                    value="D02 Grumos/Impurezas"
                    selected={
                      datosOperacion.segundoContribuidor === "D02 Grumos/Impurezas" ? true : false}>
                    D02 Grumos/Impurezas
                  </option>
                  <option
                    value="D03 Falta de escurrido"
                    selected={
                      datosOperacion.segundoContribuidor === "D03 Falta de escurrido" ? true : false}>
                    D03 Falta de escurrido
                  </option>
                  <option
                    value="D04 Pin Hole (Crater)"
                    selected={
                      datosOperacion.segundoContribuidor === "D04 Pin Hole (Crater)" ? true : false}>
                    D04 Pin Hole (Crater)
                  </option>
                  <option
                    value="D04 L)Limpieza"
                    selected={
                      datosOperacion.segundoContribuidor === "D04 L)Limpieza" ? true : false}>
                    D04 L)Limpieza)
                  </option>
                  <option
                    value="D04 F)Falso Contacto)"
                    selected={
                      datosOperacion.segundoContribuidor === "D04 F)Falso Contacto)" ? true : false}>
                    D04 F)Falso Contacto)
                  </option>
                  <option
                    value="D05 Contaminacion(Nube, Oxido,Grasa)"
                    selected={
                      datosOperacion.segundoContribuidor === "D05 Contaminacion(Nube, Oxido,Grasa)" ? true : false}>
                    D05 Contaminacion(Nube, Oxido,Grasa)
                  </option>
                  <option
                    value="D06 Cenizo"
                    selected={
                      datosOperacion.segundoContribuidor === "D06 Cenizo" ? true : false}>
                    D06 Cenizo
                  </option>
                  <option
                    value="D07 Burbuja"
                    selected={
                      datosOperacion.segundoContribuidor === "D07 Burbuja" ? true : false}>
                    D07 Burbuja
                  </option>
                  <option
                    value="D08 Falta de Pintura"
                    selected={
                      datosOperacion.segundoContribuidor === "D08 Falta de Pintura" ? true : false}>
                    D08 Falta de Pintura
                  </option>
                  <option
                    value="D9  Dañada/doblada"
                    selected={
                      datosOperacion.segundoContribuidor === "D9  Dañada/doblada" ? true : false}>
                    D9  Dañada/doblada
                  </option>
                  <option
                    value="D10 Partes mezcladas"
                    selected={
                      datosOperacion.segundoContribuidor === "D10 Partes mezcladas" ? true : false}>
                    D10 Partes mezcladas
                  </option>
                  <option
                    value="D11 Otros"
                    selected={
                      datosOperacion.segundoContribuidor === "D11 Otros" ? true : false}>
                    D11 Otros
                  </option>
                </select>
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Label className="tbold">2do contribuidor NP</Label>
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Input
                  name="segundoContribuidorNP"
                  maxLength={20}
                  value={
                    datosOperacion.segundoContribuidorNP
                  }
                  onChange={(e) =>
                    setDatosOperacion({ ...datosOperacion, segundoContribuidorNP: e.target.value })
                  }
                  placeholder=""
                />
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Label className="tbold">3er Contribuidor</Label>
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <select
                  name="tercerContribuidor"
                  className=" custom-select"
                  onChange={(e) => setDatosOperacion({ ...datosOperacion, tercerContribuidor: e.target.value })}
                >
                  <option
                    value=""
                    selected={datosOperacion.tercerContribuidor ? false : true}>
                  </option>
                  <option
                    value="D01 Rayaduras/Golpes"
                    selected={datosOperacion.tercerContribuidor === "D01 Rayaduras/Golpes" ? true : false}>
                    D01 Rayaduras/Golpes
                  </option>
                  <option
                    value="D02 Grumos/Impurezas"
                    selected={
                      datosOperacion.tercerContribuidor === "D02 Grumos/Impurezas" ? true : false}>
                    D02 Grumos/Impurezas
                  </option>
                  <option
                    value="D03 Falta de escurrido"
                    selected={
                      datosOperacion.tercerContribuidor === "D03 Falta de escurrido" ? true : false}>
                    D03 Falta de escurrido
                  </option>
                  <option
                    value="D04 Pin Hole (Crater)"
                    selected={
                      datosOperacion.tercerContribuidor === "D04 Pin Hole (Crater)" ? true : false}>
                    D04 Pin Hole (Crater)
                  </option>
                  <option
                    value="D04 L)Limpieza"
                    selected={
                      datosOperacion.tercerContribuidor === "D04 L)Limpieza" ? true : false}>
                    D04 L)Limpieza)
                  </option>
                  <option
                    value="D04 F)Falso Contacto)"
                    selected={
                      datosOperacion.tercerContribuidor === "D04 F)Falso Contacto)" ? true : false}>
                    D04 F)Falso Contacto)
                  </option>
                  <option
                    value="D05 Contaminacion(Nube, Oxido,Grasa)"
                    selected={
                      datosOperacion.tercerContribuidor === "D05 Contaminacion(Nube, Oxido,Grasa)" ? true : false}>
                    D05 Contaminacion(Nube, Oxido,Grasa)
                  </option>
                  <option
                    value="D06 Cenizo"
                    selected={
                      datosOperacion.tercerContribuidor === "D06 Cenizo" ? true : false}>
                    D06 Cenizo
                  </option>
                  <option
                    value="D07 Burbuja"
                    selected={
                      datosOperacion.tercerContribuidor === "D07 Burbuja" ? true : false}>
                    D07 Burbuja
                  </option>
                  <option
                    value="D08 Falta de Pintura"
                    selected={
                      datosOperacion.tercerContribuidor === "D08 Falta de Pintura" ? true : false}>
                    D08 Falta de Pintura
                  </option>
                  <option
                    value="D9  Dañada/doblada"
                    selected={
                      datosOperacion.tercerContribuidor === "D9  Dañada/doblada" ? true : false}>
                    D9  Dañada/doblada
                  </option>
                  <option
                    value="D10 Partes mezcladas"
                    selected={
                      datosOperacion.tercerContribuidor === "D10 Partes mezcladas" ? true : false}>
                    D10 Partes mezcladas
                  </option>
                  <option
                    value="D11 Otros"
                    selected={
                      datosOperacion.tercerContribuidor === "D11 Otros" ? true : false}>
                    D11 Otros
                  </option>
                </select>
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Label className="tbold">3er contribuidor NP</Label>
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Input
                  name="tercerContribuidorNP"
                  maxLength={20}
                  value={
                    datosOperacion.tercerContribuidorNP
                  }
                  onChange={(e) =>
                    setDatosOperacion({ ...datosOperacion, tercerContribuidorNP: e.target.value })
                  }
                  placeholder=""
                />
              </div>
            </Row>
          )}
          {(usuario.ResumenOperacionEPLaboratorio ? usuario.ResumenOperacionEPLaboratorio : false) === true && (
            <Row>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Label className={"tbold"}>SQFT Producidos</Label>
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Input
                  name="sqftProducidos"
                  maxLength={20}
                  value={
                    datosOperacion.sqftProducidos
                  }
                  onChange={(e) => setDatosOperacion({ ...datosOperacion, sqftProducidos: (handleInputChangeNum(e)) })}
                  placeholder=""
                />
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Label className="tbold">Gasto quimicos</Label>
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Input
                  name="gastosQuimicos"
                  maxLength={20}
                  value={
                    datosOperacion.gastosQuimicos
                  }
                  onChange={(e) =>
                    setDatosOperacion({ ...datosOperacion, gastosQuimicos: (handleInputChangeNum(e)) })
                  }
                  placeholder=""
                />
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Label className="tbold">Consumo de Agua</Label>
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Input
                  name="consumoAgua"
                  maxLength={20}
                  value={
                    datosOperacion.consumoAgua
                  }
                  onChange={(e) =>
                    setDatosOperacion({ ...datosOperacion, consumoAgua: (handleInputChangeNum(e)) })
                  }
                  placeholder=""
                />
              </div>
              {/* <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Label className={"tbold"}>Costo Quimico SQFT</Label>
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Label>
                  {datosOperacion.costoQuimicoSQFT}
                </Label>
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Label className="tbold">Costo Quimico vs Facturacion</Label>
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Label>
                  {datosOperacion.costoQuimicovsFacturacion}
                </Label>
              </div>*/}
            </Row>
          )}
          {(usuario.ResumenOperacionEAusentismoP ? usuario.ResumenOperacionEAusentismoP : false) === true && (
            <Row>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Label className="tbold">Falta carga Ecoat</Label>
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Input
                  name="apFaltaCarga"
                  maxLength={20}
                  value={
                    datosOperacion.apFaltaCarga
                  }
                  onChange={(e) =>
                    setDatosOperacion({ ...datosOperacion, apFaltaCarga: (handleInputChangeNum(e)) })
                  }
                  placeholder=""
                />
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Label className="tbold">Incapacidad Carga Ecoat</Label>
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Input
                  name="apIncapacidadCarga"
                  maxLength={20}
                  value={
                    datosOperacion.apIncapacidadCarga
                  }
                  onChange={(e) =>
                    setDatosOperacion({ ...datosOperacion, apIncapacidadCarga: (handleInputChangeNum(e)) })
                  }
                  placeholder=""
                />
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Label className="tbold">Falta Inspeccion Ecoat</Label>
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Input
                  name="apFaltaInspeccion"
                  maxLength={20}
                  value={
                    datosOperacion.apFaltaInspeccion
                  }
                  onChange={(e) =>
                    setDatosOperacion({ ...datosOperacion, apFaltaInspeccion: (handleInputChangeNum(e)) })
                  }
                  placeholder=""
                />
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Label className="tbold">Incap. Inspeccion Ecoat</Label>
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Input
                  name="apIncapacidadInspeccion"
                  maxLength={20}
                  value={
                    datosOperacion.apIncapacidadInspeccion
                  }
                  onChange={(e) =>
                    setDatosOperacion({ ...datosOperacion, apIncapacidadInspeccion: (handleInputChangeNum(e)) })}
                  placeholder=""
                />
              </div>

              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Label className="tbold">Falta carga Powder</Label>
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Input
                  name="apFaltaCargaPC"
                  maxLength={20}
                  value={
                    datosOperacion.apFaltaCargaPC
                  }
                  onChange={(e) =>
                    setDatosOperacion({ ...datosOperacion, apFaltaCargaPC: (handleInputChangeNum(e)) })
                  }
                  placeholder=""
                />
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Label className="tbold">Incapacidad Carga Powder</Label>
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Input
                  name="apIncapacidadCargaPC"
                  maxLength={20}
                  value={
                    datosOperacion.apIncapacidadCargaPC
                  }
                  onChange={(e) =>
                    setDatosOperacion({ ...datosOperacion, apIncapacidadCargaPC: (handleInputChangeNum(e)) })
                  }
                  placeholder=""
                />
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Label className="tbold">Falta Inspeccion Powder</Label>
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Input
                  name="apFaltaInspeccionPC"
                  maxLength={20}
                  value={
                    datosOperacion.apFaltaInspeccionPC
                  }
                  onChange={(e) =>
                    setDatosOperacion({ ...datosOperacion, apFaltaInspeccionPC: (handleInputChangeNum(e)) })
                  }
                  placeholder=""
                />
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Label className="tbold">Incap. Inspeccion Powder</Label>
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Input
                  name="apIncapacidadInspeccionPC"
                  maxLength={20}
                  value={
                    datosOperacion.apIncapacidadInspeccionPC
                  }
                  onChange={(e) =>
                    setDatosOperacion({ ...datosOperacion, apIncapacidadInspeccionPC: (handleInputChangeNum(e)) })}
                  placeholder=""
                />
              </div>
            </Row>
          )}
          {(usuario.ResumenOperacionEDatosExtra ? usuario.ResumenOperacionEDatosExtra : false) === true && (
            <Row>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Label className="tbold">Estatus de pendientes y mejoras</Label>
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Input
                  name="estatusPendientesMejoras"
                  value={
                    datosOperacion.estatusPendientesMejoras
                  }
                  onChange={(e) =>
                    setDatosOperacion({ ...datosOperacion, estatusPendientesMejoras: e.target.value })
                  }
                  placeholder=""
                />
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Label className="tbold">Acciones a tomar</Label>
              </div>
              <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                <Input
                  name="accionesaTomar"
                  value={
                    datosOperacion.accionesaTomar
                  }
                  onChange={(e) =>
                    setDatosOperacion({ ...datosOperacion, accionesaTomar: e.target.value })
                  }
                  placeholder=""
                />
              </div>
            </Row>
          )}

        </ModalBody>
        <ModalFooter>
          <Row>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
              <Alert color={color} isOpen={aVisible} toggle={onDismiss}>
                {mensajeAlert}
              </Alert>
            </div>
          </Row>
          {cargando === true && (
            <img width="150px" src="assets/img/preloader.gif" />
          )}
          {cargando === false && (
            <Button
              color="primary"
              onClick={guardarCambios}
            >
              Aceptar
            </Button>
          )}
          <Button color="danger" onClick={toggleCP}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}
export default EditarRO;
